import DB from "@/common/utils/db";

//加入我们

export function userJoinIn(query) {
  return DB({
      url: "v1/userJoinIn/createUserJoinIn",
      method: "post",
      params: query
  });
}
